import { EntriesActions } from "./EntriesActions";
import { EntriesInGroupHeading } from "./EntriesInGroupHeading";
import { EntriesHeading } from "./EntriesHeading";
import { SecondaryHeading } from "../../page/SecondaryHeading";
import { Notification } from "../../notifications/Notification";

export const EntriesListHeading = ({
    eventDivision,
    isTeams,
    isGroup,
    confirmed,
    registered,
    alternates,
    manageEntries,
}) => {
    const registeredSize = registered.length;
    const limit = eventDivision.entryLimit?.limit;
    const spotsLeft = limit && limit - registeredSize;

    const heading = isGroup ? (
        <EntriesInGroupHeading
            divisionName={eventDivision.division.name}
            isTeams={isTeams}
            registered={registeredSize}
            limit={limit}
            spotsLeft={spotsLeft}
        />
    ) : (
        <EntriesHeading
            isTeams={isTeams}
            confirmed={confirmed}
            registered={registeredSize}
            limit={limit}
            spotsLeft={spotsLeft}
        />
    );

    return (
        <>
            <SecondaryHeading
                heading={heading}
                actions={
                    manageEntries && (
                        <EntriesActions
                            withNFC={
                                !isGroup &&
                                eventDivision.formatDefinition?.useNfc
                            }
                            eventDivisionId={eventDivision.id}
                            isTeams={isTeams}
                            registered={registered}
                            alternates={alternates}
                        />
                    )
                }
            />

            {manageEntries && registeredSize >= limit && (
                <Notification
                    type="warning"
                    className="margin-bottom"
                    text={
                        registeredSize > limit
                            ? "Heads up, this division has exceeded its limit. You might like to remove some entries from the list or edit the limit."
                            : "Heads up, this division has reached its limit and registration has been closed."
                    }
                />
            )}
        </>
    );
};
